// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"708":"component---src-pages-404-js","840":"component---src-pages-index-jsx","984":"reactPlayerPreview"}[chunkId] + "-" + {"708":"837d060c94cef90ec1e6","840":"aebae213a7f42c1fe09f","984":"ced092778a86987b0008"}[chunkId] + ".js";
};